import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material"; // Changed to Material-UI Button
import { Box } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

const PreviousPageButtonCPQ = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ mb: 3, mt: 2, display: "flex", justifyContent: "center" }}>
            <Button variant="contained" color="info" startIcon={<ArrowBack />} onClick={() => navigate(-1)}>
                Previous Page
            </Button>
        </Box>
    );
};

export default PreviousPageButtonCPQ;
